export function roleChecker(roles: string[]) {
  const currentRole = localStorage.getItem("role");
  if (currentRole && roles.includes(currentRole)) {
    return true;
  }
  return false;
}
